import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const WorkOrderAdd = lazyLoader(
  () => import("Containers/WorkOrders/WorkOrderAdd/WorkOrderAdd")
);

export const WorkOrderAddPage = () => {
  return (
    <Layout>
      <WorkOrderAdd />
    </Layout>
  );
};
